/**
 * @generated SignedSource<<cc3649e97b9be1d6269151089c18fb3f>>
 * @relayHash 544e060744fb4498c2bc0371295ea8f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 44a5510e6c08eb024dc9e65741680c85b5e934e6cb2711735740a5c625e28126

import type { ConcreteRequest } from 'relay-runtime';
export type useIsSmartFoldersEnabledQuery$variables = {
  spaceKey: string;
};
export type useIsSmartFoldersEnabledQuery$data = {
  readonly space: {
    readonly id: string | null;
    readonly spaceTypeSettings: {
      readonly enabledContentTypes: {
        readonly isFoldersEnabled: boolean;
        readonly isSmartFoldersEnabled: boolean;
      };
    };
  } | null;
};
export type useIsSmartFoldersEnabledQuery = {
  response: useIsSmartFoldersEnabledQuery$data;
  variables: useIsSmartFoldersEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "SpaceTypeSettings",
        "kind": "LinkedField",
        "name": "spaceTypeSettings",
        "plural": false,
        "selections": [
          {
            "concreteType": "EnabledContentTypes",
            "kind": "LinkedField",
            "name": "enabledContentTypes",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isFoldersEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isSmartFoldersEnabled"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsSmartFoldersEnabledQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsSmartFoldersEnabledQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "544e060744fb4498c2bc0371295ea8f5",
    "id": "44a5510e6c08eb024dc9e65741680c85b5e934e6cb2711735740a5c625e28126",
    "metadata": {},
    "name": "useIsSmartFoldersEnabledQuery",
    "operationKind": "query",
    "text": "query useIsSmartFoldersEnabledQuery($spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled,isSmartFoldersEnabled}}}}"
  }
};
})();

(node as any).hash = "03675b093cffce21dc93e86a9415a3c7";

export default node;
